import http from "@/common/http"

export const position = {
	list:(data) =>{
	  return http({
	    url:"/cont/map/position/list",
	    method:"post",
	    data:data
	  })
	}
}

export default {
  position
}



// WEBPACK FOOTER //
// ./src/services/client/cont/map.js